module.exports = __webpack_public_path__ + "img/weixin_icon_logo@3x.2c1ceb13.png";